<div class="Mat-Daterange" #dateRange>
  <div class="Mat-Daterange-Output" (click)="outputClick()">
    <one-icon name="calendar-clear-outline"></one-icon>
    <div class="Mat-Daterange-Label">{{label}}</div>
  </div>
</div>